import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, MapPin, ExternalLink } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { registerButtonState } from "@/components/EventDetailModal";

function formatDateBM(yyyymmdd) {
  if (!yyyymmdd) return "";
  const [y, m, d] = yyyymmdd.split("-");
  const months = ["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"];
  return `${parseInt(d, 10)} ${months[parseInt(m, 10) - 1]} ${y}`;
}

export function UpcomingEventCard({ event, onClick }) {
  const button = registerButtonState(event);
  return (
    <Card
      className="glass-card glass-card-hover cursor-pointer"
      onClick={() => onClick?.(event)}
      data-testid={`upcoming-event-${event.id}`}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div className="flex items-center gap-2 flex-wrap">
            <StatusBadge status={event.category} />
            <StatusBadge status={event.event_status} />
          </div>
        </div>
        <h3 className="mt-3 font-heading font-semibold text-base sm:text-lg leading-tight">{event.title}</h3>
        <div className="mt-3 space-y-1.5 text-sm text-muted-foreground">
          <div className="flex items-center gap-2"><Calendar className="h-3.5 w-3.5" />{formatDateBM(event.event_date)}</div>
          <div className="flex items-center gap-2"><Clock className="h-3.5 w-3.5" />{event.start_time} – {event.end_time}</div>
          {event.location && <div className="flex items-center gap-2"><MapPin className="h-3.5 w-3.5" />{event.location}</div>}
        </div>
        <div className="mt-4">
          <Button
            size="sm"
            variant={button.disabled ? "outline" : "default"}
            className="w-full"
            disabled={button.disabled}
            onClick={(e) => {
              e.stopPropagation();
              if (event.registration_link) window.open(event.registration_link, "_blank");
            }}
            data-testid={`event-cta-${event.id}`}
          >
            {!button.disabled && <ExternalLink className="h-3.5 w-3.5" />}
            {button.label}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
